// extracted by mini-css-extract-plugin
export default {"size":"VideoPlayer_size__6rckm"};